import { FloatingIconButton } from '@/components';
import { Navigation } from 'react-feather';
import { useMantineTheme } from '@mantine/core';
import {
  GeolocateStatus,
  useGeolocateControl,
} from '@/features/geolocateContext';
import classes from './GeoLocator.module.css';
import { useCallback, useMemo } from 'react';

/**
 * This is the actual _user-clickable_ button to toggle geolocation
 */
export const GeoLocator = () => {
  const { status, setStatus } = useGeolocateControl();
  const theme = useMantineTheme();
  const isTracking = status === GeolocateStatus.TRACKING;
  const isLocating = status === GeolocateStatus.LOCATING;
  const isDisabled = status === GeolocateStatus.DISABLED;
  const classNames = useMemo(
    () =>
      `${classes.button} ${isLocating ? classes.locating : ''} ${isTracking ? classes.tracking : ''}`,
    [isLocating, isTracking]
  );

  const handleClick = useCallback(() => {
    if (status === GeolocateStatus.DISABLED) {
      setStatus(GeolocateStatus.LOCATING);
    } else {
      setStatus(GeolocateStatus.DISABLED);
    }
  }, [status, setStatus]);

  const iconColor = isDisabled
    ? theme.black
    : theme.other.mainColor.accent.normal;

  return (
    <FloatingIconButton
      Component={Navigation}
      className={classNames}
      isActive={isTracking}
      color={iconColor}
      onClick={handleClick}
      data-testid="geolocator-button"
      data-geolocation-status={status}
    />
  );
};
